import { useQuery } from '@tanstack/react-query';
import useExpress from '../../repository/react-query/useExpress';

const baseEndpoint = '/processed-fluid/route-sessions';

/**
 * Fetch the required number of seals for the current region.
 * Returns { required_seals: number } from the backend.
 * Cached with staleTime: Infinity since this is a static per-deployment value.
 */
// eslint-disable-next-line import/prefer-default-export
export const useFetchRequiredSeals = ({ enabled = true } = {}) => {
    const queryFn = useExpress({ endpoint: `${baseEndpoint}/required-seals` });
    return useQuery({
        queryKey: ['processed-fluid-required-seals'],
        queryFn,
        enabled,
        staleTime: Infinity,
    });
};
